import { Modifier } from '../modifier';
import { ModifierPriority, ModifierTags, StatusEffect } from '../modifier.type';
import { addModifier } from '../player.type';
import { StatusEffectRegistry } from '../status-effects';

export class Armoured extends Modifier {
  static readonly baseTitle = 'Armoured';
  static readonly baseText = 'Gain block equal to the value of stacks at the end of turn. Stable.';
  static readonly baseIcon = 'armoured';
  static readonly baseTags = [ModifierTags.Boon];
  static readonly basePriority = ModifierPriority.First;

  // Instance properties that can change
  title = Armoured.baseTitle;
  text = Armoured.baseText;
  icon = Armoured.baseIcon;
  tags: Array<ModifierTags> = [...Armoured.baseTags];
  priority = Armoured.basePriority;

  update(stacks: number, params?: any) {
    super.update(stacks, params);
    this.delay = true;
  }

  startTurn() {
    const focus = this.owner.statusEffects.find((modifier) => modifier.type === StatusEffect.Focus);
    if (!focus) {
      this.delay = false;
    }
  }

  endTurn() {
    addModifier(this.owner, StatusEffect.Block, this.stacks);

    if (!this.delay) {
      this.removeStacks(1);
    }
  }
}

// Register the status effect
StatusEffectRegistry.register(StatusEffect.Armoured, Armoured);
